import { Lead } from '../types/lead.types';
import { SchoolSegment } from '../types/project.types';
import { CsvExportTemplate } from '../types/csvTemplate.types';

// CSV field escaping: quote when the value contains a comma, quote, or newline.
const esc = (v: unknown): string => {
  const s = v == null ? '' : String(v);
  return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

/** Build a CSV string for the given leads using a template. One row per lead. */
export function buildExportCsv(
  leads: Lead[],
  template: CsvExportTemplate,
  segments: SchoolSegment[]
): string {
  const headerLine = template.headers.map(esc).join(',');
  const lines = leads.map(lead => {
    const row = template.buildRow(lead, { segments });
    return template.headers.map(h => esc(row[h] ?? '')).join(',');
  });
  return [headerLine, ...lines].join('\r\n');
}

/** Date-stamped filename from a template prefix. */
export function exportFilename(prefix: string): string {
  const d = new Date().toISOString().split('T')[0];
  return `${prefix}_${d}.csv`;
}

/** Trigger a browser download of CSV content. */
export function downloadCsv(content: string, filename: string): void {
  const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
